import React from 'react';
import { Translate, withLocalize } from "react-localize-redux";
import '../../css/cookieConsent.scss';


class CookieInfoComponent extends React.Component {
    render() {
        return (
            <div className='cookie-info-content content'>
                <Translate id='PersonalData.Cookies.Content' options={{ renderInnerHtml: true }} />
            </div>
        );
    }
}

export default withLocalize(CookieInfoComponent);